/**
 * Converts an amount in cents to display units (e.g., euros).
 * @param cents - Amount in cents (e.g., 10000 = €100). Defaults to 0 if undefined.
 * @returns Amount in display units (e.g., 100.00)
 */
export function convertFromCents(cents: number | undefined): number {
  return (cents ?? 0) / 100;
}

/**
 * Converts a display amount (e.g., euros) to cents.
 * Applies Math.round() to handle floating-point precision issues
 * (e.g., 12.99 * 100 = 1298.9999999999998 → 1299).
 * @param amount - Amount in display units (e.g., 100.00)
 * @returns Amount in cents (e.g., 10000), rounded to nearest integer
 */
export function convertToCents(amount: number): number {
  return Math.round(amount * 100);
}
